module.exports = __webpack_public_path__ + "img/80.fcde0e78.jpg";